import { AxiosResponse } from 'axios';
import { auth, NewPasswordResetRequest } from '@/shared/infrastructure/clients';

type NewPasswordResponseSuccess = any;

type NewPasswordResponseError = {
  error: string;
};

type NewPasswordResponse = NewPasswordResponseSuccess | NewPasswordResponseError;

const updatePassword = async (credentials: NewPasswordResetRequest): Promise<AxiosResponse> =>
  auth().newPasswordReset(credentials);

export { updatePassword };
export type { NewPasswordResponse };
